import React from 'react';

const About: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
      <h1 className="text-3xl font-bold text-domired-600 mb-6">Acerca de</h1>
      
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold mb-2">Livan Andrés Lebron Urbaez</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Soy un apasionado desarrollador web dominicano con experiencia en la creación 
            de aplicaciones web modernas y redes sociales. Mi objetivo es crear plataformas 
            que conecten a las personas y fomenten la comunicación en la comunidad dominicana.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Sobre DomiRed</h2>
          <p className="text-gray-700 dark:text-gray-300">
            DomiRed nace con la misión de crear un espacio digital donde los dominicanos 
            puedan conectarse, compartir ideas y construir comunidad. Nuestra plataforma 
            está diseñada para ser intuitiva, rápida y adaptada a las necesidades de 
            nuestra comunidad.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Nuestra Misión</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Conectar a los dominicanos en todo el mundo a través de una plataforma 
            digital que promueva la comunicación, el intercambio cultural y el 
            fortalecimiento de nuestra identidad, mientras ofrecemos una experiencia 
            de usuario excepcional y respetamos la privacidad de cada miembro.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
